import { useEffect } from 'react';
import { getDefaultPlanForRegion } from '../helpers/travel/travelCalcHelpers';

// eslint-disable-next-line consistent-return
const selectDefaultPlan = (plansWithAllowedLimitRegionAndAge, defaultSelectedPlan) => {
  if (plansWithAllowedLimitRegionAndAge?.includes(defaultSelectedPlan)) {
    return defaultSelectedPlan;
  } if (plansWithAllowedLimitRegionAndAge.length) {
    return plansWithAllowedLimitRegionAndAge[0];
  }
};

function useDefaultPlanSelection(
  showTravelPlans,
  region,
  age,
  plansWithAllowedLimitRegionAndAge,
  selectedPlan,
  setSelectedPlan,
  STATIC_PLANS,
) {
  useEffect(() => {
    if (showTravelPlans && region) {
      const plan = !!selectedPlan
          && Object.values(STATIC_PLANS).find((p) => p.label === selectedPlan);
      if (!!plan && plansWithAllowedLimitRegionAndAge.includes(plan)) {
        return;
      }
      const defaultSelectedPlan = getDefaultPlanForRegion(region);
      const planToSelect = selectDefaultPlan(
        plansWithAllowedLimitRegionAndAge,
        defaultSelectedPlan,
      );
      if (planToSelect) {
        setSelectedPlan(planToSelect.label);
      }
    }
  }, [
    showTravelPlans,
    region,
    age,
    plansWithAllowedLimitRegionAndAge,
    selectedPlan,
    setSelectedPlan,
    STATIC_PLANS,
  ]);
}

export default useDefaultPlanSelection;
